import JraMembershipOptions from './JraMembershipOptions';
import { parents } from '../../../../util/dom';
import { dispatchInputChangeEvent } from '../helpers';

export default class JraJoinPaymentOptions extends JraMembershipOptions {
  static JOIN_MEMBERSHIP_PAYMENT_TYPE_CHANGE_EVENT = 'joinMembershipPaymentTypeChangeEvent';

  constructor(element, encodeDecodeKey) {
    super(element, encodeDecodeKey);

    this.element = element;

    this.toggleMembershipType = this.toggleMembershipType.bind(this);

    this.initJraJoinPaymentOptions();
  }

  initJraJoinPaymentOptions() {
    this.membershipName = this.requiredValidationMessage;
  }

  togglePaymentOptionsDisplay = (subscriptionType, location) => {
    // function will execute on subscription type change OR on membership type change
    let optionType = subscriptionType !== undefined ? subscriptionType : location;
    optionType = optionType.replace(/[0-9]/g, '');
    const overseasOption = location === 'Overseas';
    const ukOption = location === 'UK';
    const paymentOptionsHidden = this.element.classList.contains('JraMembershipBlock-hidden');

    if ((overseasOption && paymentOptionsHidden) || (subscriptionType && paymentOptionsHidden)) {
      // display payment options container if hidden & subscriptionType or location = Overseas
      this.element.classList.remove('JraMembershipBlock-hidden');
    } else if (ukOption && !paymentOptionsHidden) {
      // if location = UK and payment options are in view, hide payment options container
      this.element.classList.add('JraMembershipBlock-hidden');
    }

    this.membershipPaymentTypeRadioButtons.forEach((button) => {
      const buttonParent = parents(button, '[data-jra-membership-radio-control]')[0];
      const buttonMatchesOptionType = button.id.toLowerCase().includes(optionType.toLowerCase());
      const buttonParentActive = buttonParent.classList.contains('JraMembershipBlock_radioControl-active');

      // display all payment radio buttons that match the option type if overseas or subscription
      if ((subscriptionType || overseasOption) && buttonMatchesOptionType && !buttonParentActive) {
        buttonParent.classList.add('JraMembershipBlock_radioControl-active');
      }

      // for previously active buttons OR all buttons if location = UK, remove active class
      if (
        ((subscriptionType || overseasOption) && !buttonMatchesOptionType && buttonParentActive)
        || (ukOption && buttonParentActive)
      ) {
        buttonParent.classList.remove('JraMembershipBlock_radioControl-active');
      }

      // if subscriptionType then preselect direct debit option for that type
      if (subscriptionType) {
        const directDebitSubscriptionButton = button.dataset.jraMembershipPaymentType === 'Direct Debit' && buttonMatchesOptionType;

        if (directDebitSubscriptionButton) {
          dispatchInputChangeEvent(button);
        }
      }
    });
  }


  toggleMembershipType(event) {
    super.toggleMembershipType(event);
    this.togglePaymentOptionsDisplay(undefined, event.currentTarget.value);
  }
}
